import { c as _c } from "react/compiler-runtime";
import { isNil } from 'ramda';
import { tv } from 'tailwind-variants';
import { Body } from '../typography/Body';
import { Label } from '../typography/Label';
import { RadioGroup, RadioGroupItem } from './RadioGroup';
import type { RadioOption } from '../types/form';
interface RadioGroupListProps {
  options: RadioOption<string | boolean>[];
  labelSize?: 'sm' | 'md' | 'lg';
  /** Use this to render a custom postfix for each option or programatically choose when to show it with passed props */
  optionPostfix?: (option: RadioOption<string | boolean>, currentValue?: string | null | undefined) => React.ReactNode;
}
const radioGroupListItem = tv({
  base: 'self-start',
  variants: {
    labelSize: {
      sm: 'mt-0',
      md: 'mt-0.5',
      lg: 'mt-1'
    }
  },
  defaultVariants: {
    labelSize: 'lg'
  }
});
function RadioGroupList(t0) {
  const $ = _c(8);
  let T0;
  let t1;
  let t2;
  if ($[0] !== t0) {
    const {
      options,
      optionPostfix,
      labelSize: t3,
      ...props
    } = t0;
    const labelSize = t3 === undefined ? "lg" : t3;
    const helperTextSize = labelSize === "lg" ? "md" : labelSize;
    const renderPostfix = option => {
      if (isNil(optionPostfix)) {
        return null;
      }
      if (typeof optionPostfix === "function") {
        const postfix = optionPostfix(option, props.value);
        if (isNil(postfix)) {
          return null;
        }
        return <div className="mt-2">{postfix}</div>;
      }
      return <div className="mt-2">{optionPostfix}</div>;
    };
    T0 = RadioGroup;
    t1 = props;
    t2 = options.map(option_0 => <div className="flex items-center gap-2" key={String(option_0.value)}><RadioGroupItem className={radioGroupListItem({
        labelSize
      })} disabled={option_0.disabled} id={option_0.value?.toString()} value={String(option_0.value)} /><div className="flex flex-1 flex-col"><Label className={option_0.disabled ? "cursor-not-allowed" : "cursor-pointer"} disabled={option_0.disabled} htmlFor={option_0.value?.toString()} size={labelSize}>{option_0.label}</Label>{option_0.helperText && <Body className="text-content-secondary" disabled={option_0.disabled} size={helperTextSize}>{option_0.helperText}</Body>}{renderPostfix(option_0)}</div></div>);
    $[0] = t0;
    $[1] = T0;
    $[2] = t1;
    $[3] = t2;
  } else {
    T0 = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== T0 || $[5] !== t1 || $[6] !== t2) {
    t3 = <T0 {...t1}>{t2}</T0>;
    $[4] = T0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
export { RadioGroupList };
export type { RadioGroupListProps };